/**
 * @file VeriomeVerticalViewField.js
 * @description displays:
 * 
 *              Label 
 *              Value
 * 
 *  vertically (view-only)
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Feb 11, 2022 12:17
 */
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Typography from '@mui/material/Typography';

import { stringExists } from 'src/@common/utilities';

const StyledDiv = styled.div`
        display: block;
`;

const LabelText = (props) => {
    const {
        label,
        className,
    } = props;

    return (
        <Typography
            sx={{ lineHeight: 1, m: 1 }}
            className={className}
            variant="overline"
            display="block"
        >
            {`${label}: `}
        </Typography>
    );
}

LabelText.propTypes = {
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
};

const ValueText = (props) => {
    const {
        value,
        className,
    } = props;

    return (
        <Typography
            sx={{ lineHeight: 1.5 }}
            className={className}
        >
            {value}
        </Typography>
    );
}

ValueText.propTypes = {
    value: PropTypes.string.isRequired,
    className: PropTypes.string,
};

function VeriomeVerticalViewField(props) {
    const {
        label = 'Property',
        value = '',
        labelClassName = "text-12",
        valueClassName = "text-14 font-medium"
    } = props;

    return (
        <StyledDiv>
            {stringExists(label) &&
                <LabelText label={label} className={labelClassName} />
            }
            <ValueText value={value} className={valueClassName} />
        </StyledDiv>
    );
}

VeriomeVerticalViewField.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    labelClassName: PropTypes.string,
    valueClassName: PropTypes.string,
};

export default VeriomeVerticalViewField;